'use client';

import { useState, useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import { AdSlot } from '../pin/AdSlot';

export function AdInPage() {
  const [visible, setVisible] = useState(false);
  const [closed, setClosed] = useState(false);
  const [closeable, setCloseable] = useState(false);
  const pathname = usePathname();
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const closeTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const reopenTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setClosed(false);
    setVisible(false);
    setCloseable(false);

    timerRef.current = setTimeout(() => {
      setVisible(true);
      closeTimerRef.current = setTimeout(() => {
        setCloseable(true);
      }, 3000);
    }, 1500);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
      if (reopenTimerRef.current) clearTimeout(reopenTimerRef.current);
    };
  }, [pathname]);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check(); // chạy lần đầu
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  // Sau khi đóng, 60s sẽ hiện lại
  useEffect(() => {
    if (!closed) return;

    reopenTimerRef.current = setTimeout(() => {
      setClosed(false);
      setVisible(false);
      setCloseable(false);

      timerRef.current = setTimeout(() => {
        setVisible(true);
        closeTimerRef.current = setTimeout(() => {
          setCloseable(true);
        }, 3000);
      }, 500);
    }, 180_000);

    return () => {
      if (reopenTimerRef.current) clearTimeout(reopenTimerRef.current);
    };
  }, [closed]);

  if (closed) return null;

  // nếu màn hình nhỏ hơn 768px thì hiển thị quảng cáo popup thay vì banner dính
  if (isMobile) {
    return (
      <div style={{
        position: 'fixed',
        bottom: 0
      }}>
        <AdSlot type="socialBar" />
      </div>
    );
  }

  return (
    <div
      style={{
        position: 'sticky',
        top: 52,        // dính ngay dưới header khi scroll
        zIndex: 40,    // thấp hơn header z-50
        transition: 'opacity 1s ease, transform 1s ease',
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(-10px)',
        pointerEvents: visible ? 'auto' : 'none',
        paddingTop: '10px',
      }}
    >
      <div style={{ position: 'relative' }}>
        <button
          onClick={() => closeable && setClosed(true)}
          aria-label="Đóng quảng cáo"
          style={{
            position: 'absolute',
            bottom: '20px',
            right: '20px',
            zIndex: 10000,
            width: '22px',
            height: '22px',
            borderRadius: '50%',
            background: 'rgba(0,0,0,0.7)',
            color: '#fff',
            cursor: closeable ? 'pointer' : 'default',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '12px',
            lineHeight: 1,
            transition: 'opacity 0.3s ease',
            opacity: closeable ? 1 : 0,
            pointerEvents: closeable ? 'auto' : 'none',
            border: '1px solid rgba(255,255,255,0.7)',
          }}
        >
          ✕
        </button>

        <AdSlot type="728x90-2" />

        <p style={{
          textAlign: 'center',
          fontSize: '10px',
          color: '#6b7280',
          marginTop: '2px',
        }}>
          Ads
        </p>
      </div>
    </div>
  );
}